"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useCurrentAccountId_1 = require("./useCurrentAccountId");
Object.defineProperty(exports, "useCurrentAccountId", { enumerable: true, get: function () { return useCurrentAccountId_1.useCurrentAccountId; } });
Object.defineProperty(exports, "CurrentAccountIdProvider", { enumerable: true, get: function () { return useCurrentAccountId_1.CurrentAccountIdProvider; } });
